import React, { useCallback, useEffect, useState } from "react";

import Table from "../../components/table/Table";
import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import moment from "moment/moment";

import Loader from "../../components/Loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { student } from "./content";
import StudentCard from "../../components/StudentCard/StudentCard";

const Students = () => {
  const [data, setData] = useState(student);
  const { currUserData } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handleDelete = (rowIndex) => {
    const newData = [...data];
    newData.splice(rowIndex, 1);
    setData(newData);
  };

  const handleEdit = (rowIndex) => {
    const newData = [...data];
    const updatedValue = prompt(
      "Enter new value:",
      newData[rowIndex].CenterName
    );
    if (updatedValue) {
      newData[rowIndex].CenterName = updatedValue;
      setData(newData);
    }
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      getStudentData(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );
  const handleToggleStatus = (rowIndex) => {
    const newData = [...data];
    newData[rowIndex].status = !newData[rowIndex].status;
    setData(newData);
  };

  const getStudentData = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/student/getStudents?page=${
        pageIndex + 1
      }&limit=${pageSize}&search=${term}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      const premiumOnly = res?.data?.filter((emp) => emp.isPremium === true);
      setTotalCount(res?.totalStudents);
      setData(premiumOnly);
      setIsLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Email Id",
        accessor: "email",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },

      {
        Header: "Enrolled Date",
        accessor: "createdAt",
        Cell: ({ row }) =>
          moment(row.original.createdAt, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   Cell: ({ row }) => (
      //     <p
      //       style={{
      //         fontSize: "14px",
      //         textAlign: "center",
      //         borderRadius: "10px",
      //         padding: "5px 10px",
      //         background:
      //           row.original.status === "complete"
      //             ? "#EBFFE8"
      //             : row.original.status === "closed"
      //             ? "#FFE6E1"
      //             : "#EEE8FF",
      //         color:
      //           row.original.status === "complete"
      //             ? "#14CC26"
      //             : row.original.status === "closed"
      //             ? "#FF613E"
      //             : "#481FEB",
      //       }}
      //     >
      //       {row.original.status}
      //     </p>
      //   ),
      // },
      // {
      //   Header: "Action",
      //   accessor: "",
      //   Cell: ({ row }) => (
      //     <span
      //       className=""
      //       // onClick={() => {
      //       //   navigate(`/ownerUsers/${row.original._id}`);
      //       // }}
      //     >
      //       <i class="fas fa-ellipsis-h"></i>
      //     </span>
      //   ),
      // },
    ],
    []
  );

  useEffect(() => {
    getStudentData();
  }, [pageIndex, pageSize]);

  return (
    <>
      <div className="appointment_list p-40">
        {/* <div className="row mb-4">
          <div className="col-md-4">
            <StudentCard />
          </div>
          <div className="col-md-4">
            <StudentCard />
          </div>
          <div className="col-md-4">
            <StudentCard />
          </div>
        </div> */}
        <div className="page_heading mb-5">
          <div>
            <p className="heading">Students List</p>
          </div>
        </div>

        <div className="appointment_list_box mt-5">
          <div className="row">
            <div className="col-md-12">
              {/* <div className="box_wrapper mb-4">
                <div className="table-content">
                  <div className="row page-header">
                    <div className="col">
                      <div className="d-flex justify-content-between p-20">
                        <h5 style={{ color: "#362F29" }} className="page-title">
                           New({dataSource.length}) 
                        </h5>
                        <div className="d-flex">
                          <SearchBar />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <Table
                columns={columns}
                data={data}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onToggleStatus={handleToggleStatus}
                onSearch={handelSearch}
                isLoading={isLoading}
                totalCount={totalCount}
                pageIndex={pageIndex}
                pageSize={pageSize}
                setPageIndex={setPageIndex}
                setPageSize={setPageSize}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Students;
